const SCORE_MAX_POINTS = 100;
const SCORE_SPEED_FACTOR = 0.1;
const SCORE_ACCURACY_FACTOR = 0.5;
const SCORE_MIN_POINTS = 10;

export function validateDecision(answerData, questionAccountItemId, selectedOptionAccountItemId) {
  const answer = answerData?.find(a => a.item_id === questionAccountItemId);
  if (!answer) return false;

  return answer.parent_ids.includes(selectedOptionAccountItemId);
}

export function calculateScore({ timeElapsedSeconds, totalTries }) {
  const speedImpact = Math.max(0, 1 - SCORE_SPEED_FACTOR * timeElapsedSeconds);
  const accuracyImpact = totalTries === 1 ? 1 : Math.pow(SCORE_ACCURACY_FACTOR, totalTries);
  return Math.max(SCORE_MAX_POINTS * speedImpact * accuracyImpact, SCORE_MIN_POINTS);
}

const SESSION_STORAGE_PREFIX = 'normal_session_';

export function saveSessionToStorage(gameSessionId, sessionData) {
  const key = `${SESSION_STORAGE_PREFIX}${gameSessionId}`;
  localStorage.setItem(key, JSON.stringify(sessionData));
}

export function loadSessionFromStorage(gameSessionId) {
  const key = `${SESSION_STORAGE_PREFIX}${gameSessionId}`;
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
}

export function clearSessionFromStorage(gameSessionId) {
  const key = `${SESSION_STORAGE_PREFIX}${gameSessionId}`;
  localStorage.removeItem(key);
}

export function formatSecondsToTimeString(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function formatDecisionsForBulkPost(decisions, gameTimeElapsedSeconds) {
  // Fallback for legacy decisions that don't carry their own
  // game_time_elapsed; otherwise use the per-decision cumulative value
  // so the field grows monotonically across rows.
  const fallbackGameTimeElapsed = formatSecondsToTimeString(gameTimeElapsedSeconds);

  return decisions.map(d => ({
    game: d.game,
    game_session: d.game_session,
    question: d.question,
    selected_option: d.selected_option,
    time_elapsed: formatSecondsToTimeString(d.time_elapsed),
    game_time_elapsed: d.game_time_elapsed != null
      ? formatSecondsToTimeString(d.game_time_elapsed)
      : fallbackGameTimeElapsed,
    timestamp: d.timestamp
  }));
}
